import React, { useEffect } from "react";
import ModalDetailsRow from "../../../components/ModalDetailsRow/ModalDetailsRow.component";
import { MixPanel } from "../../../shared/MixPanel/MixPanel";
import useAuditTrailDetails from "../../../custom-hooks/useAuditTrailDetails";

interface AuditTrailModalProps {
  properties: {
    dataRecord: {
      action_date: string;
      audit_type: string;
      username: string;
      client_ip_address: string;
      id: string;
    };
    type: string;
  };
  onCloseModal: () => void;
}

const AuditTrailModal: React.FC<AuditTrailModalProps> = ({
  properties,
  properties: { dataRecord, type },
  onCloseModal,
}) => {
  const printHandler = () => {};
  const { action_date, audit_type, username, client_ip_address, id } =
    dataRecord;

  useEffect(() => {
    MixPanel.track(`Page View: AuditTrail.tsx`, {
      page: "AuditTrail.tsx",
    });
  }, []);

  const { data: auditTrailData, isLoading } = useAuditTrailDetails({
    auditTrailId: id,
  });

  return (
    <div className="Modal__dialog animated slideInDown" role="document">
      <div
        className="AuditTrailModal Modal__content"
        style={{ overflow: "hidden" }}
      >
        {(() => {
          switch (type) {
            case "alert":
              return (
                <div className="Modal__body text-center">
                  <h3 className="Modal__title p-b-2 text-center">
                    Invalid date range
                  </h3>
                  <button
                    type="button"
                    className="btn zoom-element btn login-btn m-t-1"
                    onClick={onCloseModal}
                    data-dismiss="modal"
                  >
                    <i className="fas fa-times-circle"></i>
                    &nbsp; Go Back
                  </button>
                </div>
              );
            default:
              return (
                <div className="Modal__body">
                  <h3 className="Modal__title p-b-2 text-center">
                    Audit Trail Information
                  </h3>
                  {/* AuditTrail ModalContainer */}
                  <form>
                    {auditTrailData && auditTrailData?.data.customerDetails && (
                      <>
                        <ModalDetailsRow
                          label="Customer First Name"
                          value={auditTrailData.data.customerDetails.firstName}
                          icon="fas fa-user-circle"
                        />
                        <ModalDetailsRow
                          label="Customer Last Name"
                          value={auditTrailData.data.customerDetails.lastName}
                          icon="far fa-calendar-alt"
                        />
                        <ModalDetailsRow
                          label="Customer Email"
                          value={auditTrailData.data.customerDetails.email}
                          icon="far fa-calendar-alt"
                        />
                        <ModalDetailsRow
                          label="Customer ID"
                          value={auditTrailData.data.customerDetails.customerId}
                          icon="far fa-calendar-alt"
                        />
                        <ModalDetailsRow
                          label="Customer Phone Number"
                          value={
                            auditTrailData.data.customerDetails.phoneNumber
                          }
                          icon="far fa-calendar-alt"
                        />
                      </>
                    )}
                    <ModalDetailsRow
                      label="Username"
                      value={username}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Client IP Address"
                      value={client_ip_address}
                      icon="far fa-calendar-alt"
                    />
                    <ModalDetailsRow
                      label="Action"
                      value={auditTrailData?.data.action}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Comment"
                      value={auditTrailData?.data.comment}
                      icon="fas fa-user-circle"
                      type="textarea"
                    />
                    <ModalDetailsRow
                      label="Entity Name"
                      value={auditTrailData?.data.entityName}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Initiator Email"
                      value={auditTrailData?.data?.initiatedByDetails?.email}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Initiator First Name"
                      value={
                        auditTrailData?.data?.initiatedByDetails?.firstName
                      }
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Initiator Last Name"
                      value={auditTrailData?.data?.initiatedByDetails?.lastName}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Initiator UserId"
                      value={auditTrailData?.data?.initiatedByDetails?.userId}
                      icon="fas fa-user-circle"
                    />
                    <ModalDetailsRow
                      label="Date/Time"
                      value={`${action_date.substring(
                        0,
                        10,
                      )} / ${action_date.substring(11, 19)}`}
                      icon="fas fa-user-circle"
                    />

                    <div className="Form__action-buttons m-t-1">
                      {/* <button
                        type="button"
                        className="btn zoom-element btn login-btn m-0 mr-auto"
                        onClick={printHandler}
                      >
                        <i className="fas fa-print"></i>
                        &nbsp; Print
                      </button> */}
                      <button
                        type="button"
                        className="btn zoom-element btn login-btn m-0 ml-auto"
                        onClick={onCloseModal}
                        data-dismiss="modal"
                      >
                        <i className="fas fa-times-circle"></i>
                        &nbsp; Go Back
                      </button>
                    </div>
                  </form>
                </div>
              );
          }
        })()}
      </div>
    </div>
  );
};

export default AuditTrailModal;
